export default __webpack_public_path__ + "static/media/racingMob@3x.c9b3b2b3.png";